import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from './ui/button';

export function EmptyState({
  eyebrow = 'Nothing here',
  title = 'Nothing to show — yet.',
  description = '',
  action,
  icon,
  className = '',
  testId = 'empty-state',
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.85, 0, 0.15, 1] }}
      className={`py-24 md:py-32 text-center ${className}`}
      data-testid={testId}
    >
      {icon && <div className="mx-auto mb-6 h-10 w-10 text-muted-foreground">{icon}</div>}
      <p className="overline text-muted-foreground">{eyebrow}</p>
      <h2 className="mt-4 font-display text-4xl md:text-5xl leading-[1.05]">{title}</h2>
      {description && <p className="mt-4 max-w-md mx-auto text-muted-foreground leading-relaxed">{description}</p>}
      {action && (
        <div className="mt-8 flex justify-center gap-3">
          {typeof action === 'string' ? (
            <Button asChild data-testid={`${testId}-action`}><Link to="/shop">{action}</Link></Button>
          ) : (
            action
          )}
        </div>
      )}
    </motion.div>
  );
}

export function ErrorState({
  title = 'Something went sideways.',
  description = 'A quiet error. Try again in a moment.',
  onRetry,
  className = '',
}) {
  return (
    <div className={`py-24 md:py-32 text-center ${className}`} role="alert" data-testid="error-state">
      <p className="overline text-muted-foreground">Error</p>
      <h2 className="mt-4 font-display text-4xl md:text-5xl leading-[1.05]">{title}</h2>
      <p className="mt-4 max-w-md mx-auto text-muted-foreground leading-relaxed">{description}</p>
      {onRetry && (
        <div className="mt-8">
          <Button onClick={onRetry} data-testid="error-retry">Try again</Button>
        </div>
      )}
    </div>
  );
}
